import React, { useEffect, useState } from 'react';
import Classes from './Settings.module.css';
import InfoTab from './Comp/InfoTab';
import ResetPassword from './Comp/ResetPassword';
import { useNavigate, useParams } from 'react-router-dom';
import { authActions } from '../../../../redux-store';
import { useDispatch } from 'react-redux';
import Team from './Comp/Team/Team';

export default function Settings() {
    const navigateTo = useNavigate();
    const { tab } = useParams();
    const [activeTab, setactiveTab] = useState(tab);
    const dispatch = useDispatch();

    useEffect(() => {
        setactiveTab(tab);
    }, [tab])
    
    const handleLogout = async () => {
        localStorage.clear();
        sessionStorage.clear();
        await dispatch(authActions.logout());
    };

    return (
        <div className={`${Classes.hero} layoutPadding`}>
            <div className={Classes.header}>
                <div>
                    <h3 className={Classes.title3}>Settings</h3>
                    <h5 className={Classes.text}>Manage your account settings.</h5>
                </div>
            </div>

            <div className={Classes.navigation}>
                <button
                    className={`${Classes.btn1} ${activeTab === 'profile' ? Classes.activeBtn : ''}`}
                    onClick={() => navigateTo('/settings/profile')}
                >
                    <h5>Profile</h5>
                </button>
                <button
                    className={`${Classes.btn2} ${activeTab === 'password' ? Classes.activeBtn : ''}`}
                    onClick={() => navigateTo('/settings/password')}
                >
                    <h5>Password</h5>
                </button>
                <button
                    className={`${Classes.btn2} ${activeTab === 'team' ? Classes.activeBtn : ''}`}
                    onClick={() => navigateTo('/settings/team')}
                >
                    <h5>Team</h5>
                </button>
                {/* <button className={Classes.btn3}>
                    <h5>Billing</h5>
                </button> */}
                <button className={Classes.btn4} onClick={handleLogout}>
                    <h5>Sign Out</h5>
                </button>
            </div>

            {activeTab === 'profile' && (
                <>
                    <h3 className="mb-20">Profile</h3>
                    <InfoTab />
                </>
            )}
            {activeTab === 'password' && (
                <>
                    <h3 className="mb-20">Reset Password</h3>
                    <ResetPassword />
                </>
            )}
            {activeTab === 'team' && (
                <>
                    <Team />
                </>
            )}

        </div>
    );
}
